export default __webpack_public_path__ + "static/media/email.4a71c73c.svg";